import apiService from "./apiService";


export const getFocusedItems = () => {
  return apiService.get(URIS.focused_items);
};

export const getFocusedItem = (id) => {
  return apiService.get(URIS_D('focused_item', id));
};



export const getCmsFocusedItems = ({searchText, type, month} = {}) => {
  const params = {

    ...(month!== undefined && {month}),
    ...(type && {type}),
    ...(searchText && {title: searchText})
  };

  return apiService.get(URIS.cms_focused_items, {params});
};



const URIS_D = (url, param1) => {
  return {
    focused_item: `${URIS.focused_items}/${param1}`
  }[url];
};

const URIS = {
  focused_items: '/v1/focus-items',
  cms_focused_items: '/v1/cms/focus-items',
};
